import { ArrowRightIcon } from 'lucide-react';
import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Link } from 'react-router';
import { BLOG_LANGS } from '../../../types/blogTypes';
import { useBlogTrans } from '../../blogHooks/useBlogTrans';
import Frame from '../../uikit/Frame';
import { MarkdownViewer } from '../../views/common/editor/MarkdownViewer';
import { useMobxInstance } from '../../clientUtils/mobxUtil';
import BlogJsonld from '../BlogJsonld';
import BlogMetaHeader from '../BlogMetaHeader';
import { useBlogContext } from '../BlogProvider';
import { BlogLangButton } from './BlogLangButton';
import { BlogMemberList } from './BlogMemberList';
import BlogPostList from '../list/BlogPostList';
import Box from '../../uikit/Box';

class ViewStore {
    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {
        runInAction(() => {});
    }
}

const HomePage = observer(() => {
    const viewStore = useMobxInstance(ViewStore);

    const { lang } = useBlogContext();
    const { trans } = useBlogTrans();

    useEffect(() => {
        viewStore.fetch();
    }, [viewStore]);

    return (
        <Frame>
            <BlogMetaHeader description={trans('blogIntroDesc')} />
            <BlogJsonld type="WebSite" />
            <BlogJsonld type="Organization" />
            <div className="hero bg-base-200">
                <div className="hero-content text-center">
                    <div className="w-full">
                        <h1 className="mt-4 text-5xl font-bold">Retire in 40s</h1>
                        <h2 className="mt-14 text-2xl font-bold">{trans('blogIntroTitle')}</h2>
                        <div className="mt-14 text-lg leading-relaxed">
                            <MarkdownViewer markdown={trans('blogIntroDesc')} />
                        </div>
                        <div className="divider mt-20">Choose your language</div>
                        <div className="mx-auto mt-20 grid max-w-96 grid-cols-3 grid-rows-3 items-center justify-center gap-5">
                            {BLOG_LANGS.map((lang) => (
                                <BlogLangButton
                                    key={lang}
                                    lang={lang}
                                    className="btn btn-outline min-w-20"
                                    activeClassName="btn-primary"
                                />
                            ))}
                        </div>
                        <div className="mt-10">and</div>
                        <div className="mt-10">
                            <Link
                                to={`/${lang}/post/economic-news`}
                                className="btn btn-primary"
                                preventScrollReset={false}
                            >
                                {trans('goToBlog')}
                                <ArrowRightIcon className="h-4 w-4" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <Box className="mt-10">
                <Box.Title title={trans('economic-news')} />
                <BlogPostList category="economic-news" displayCount={3} />
                <Box.More link={`/${lang}/post/economic-news`}>{trans('more')}</Box.More>
            </Box>
            <Box>
                <Box.Title title={trans('classical-music')} />
                <BlogPostList category="classical-music" displayCount={3} />
                <Box.More link={`/${lang}/post/classical-music`}>{trans('more')}</Box.More>
            </Box>
            <div className="divider mt-20 mb-10">Members</div>
            <BlogMemberList />
        </Frame>
    );
});

export default HomePage;
